import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddLastPage } from './add-last.page';

const routes: Routes = [
  {
    path: '',
    component: AddLastPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AddLastPageRoutingModule {}
